import type { AxiosInstance } from 'axios';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type { ServiceResult } from '../types/common/ServiceResult';
import type { CityViewModel, CityCreateModel, CityUpdateModel } from '../types/city';
import { apiClient } from '../client/client';
import { buildPaginationParams } from '../client/queryParams';

export interface CityQuery {
  pagination?: { pageSize?: number; pageNumber?: number } | null;
}

export class CityService {
  private static readonly BASE = '/api/city';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async getAll(query?: CityQuery): Promise<ServiceResultT<CityViewModel[]>> {
    const pagination = query?.pagination ?? { pageSize: 500, pageNumber: 1 };
    const params = buildPaginationParams(pagination) as Record<string, number>;
    const { data } = await this.client.get<ServiceResultT<CityViewModel[]>>(
      CityService.BASE,
      { params }
    );
    return data;
  }

  async getById(id: number | string): Promise<ServiceResultT<CityViewModel>> {
    const { data } = await this.client.get<ServiceResultT<CityViewModel>>(
      `${CityService.BASE}/${id}`
    );
    return data;
  }

  async create(payload: CityCreateModel): Promise<ServiceResultT<CityViewModel>> {
    const { data } = await this.client.post<ServiceResultT<CityViewModel>>(
      CityService.BASE,
      payload
    );
    return data;
  }

  async update(id: number | string, payload: CityUpdateModel): Promise<ServiceResultT<CityViewModel>> {
    const { data } = await this.client.put<ServiceResultT<CityViewModel>>(
      `${CityService.BASE}/${id}`,
      payload
    );
    return data;
  }

  async delete(id: number | string): Promise<ServiceResult> {
    const { data } = await this.client.delete<ServiceResult>(`${CityService.BASE}/${id}`);
    return data;
  }
}

export const cityService = new CityService();
